export const dmsTr = {
  archive: {
    title: 'Belge arşivi',
    subtitle: 'Genel belgeler, sözleşmeler, kayıtlar ve şablonlar için merkezi arşiv.',
  },
  manager: {
    title: 'Belgeler ve dosyalar',
    description: 'Sağlama toplamları ve izlenebilir geçmişi olan korumalı dosyalar.',
  },
  upload: {
    dropTitle: 'Dosyaları buraya bırakın veya seçin',
    dropHint: "PDF, JPG, PNG, WebP, TXT, CSV, DOCX veya XLSX · dosya başına 50 MB'a kadar",
    select: 'Dosyaları seç',
    categoryHint: 'Seçilen kategori bu yüklemedeki tüm dosyalar için geçerlidir.',
    success_one: '{{count}} dosyası yüklendi.',
    success_other: '{{count}} dosyaları yüklendi.',
  },
  search: { label: 'Belgeleri arayın', placeholder: 'Ad, unvan veya etiket…' },
  fields: {
    title: 'Görünen ad',
    category: 'Kategori',
    tags: 'Etiketler (virgülle ayrılmış)',
    description: 'Açıklama / not',
  },
  portal: {
    label: 'Müşteri portalında paylaş',
    hint: 'Yalnızca açıkça paylaşılan dosyalar bu müşterinin portal kullanıcılarına görünür.',
    visible: 'Portalda görünür',
  },
  categories: {
    GENERAL_FILE: 'Genel dosya',
    CONTRACT: 'Sözleşme',
    CERTIFICATE: 'Sertifika',
    DATASHEET: 'Veri sayfası',
    INVOICE_RECEIPT: 'Fatura / makbuz',
    CORRESPONDENCE: 'Yazışma',
    CUSTOMS_DECLARATION: 'Gümrük beyannamesi',
    IMAGE: 'Resim',
  },
  actions: { preview: 'Önizleme', previewNamed: '{{name}} için önizlemeyi aç', download: 'İndir' },
  item: { uploaded: '{{date}} · {{user}}' },
  empty: {
    title: 'Henüz dosya yok',
    description: 'İlk belgeleri sürükleyip bırakarak ekleyin.',
    search: 'Aramanızla eşleşen belge yok.',
  },
  edit: { title: 'Belgeyi düzenle', success: 'Belge ayrıntıları kaydedildi.' },
  delete: {
    title: 'Belge kalıcı olarak silinsin mi?',
    description:
      '“{{name}}” arşivden ve korumalı depolama alanından kaldırılacak. İşlem denetim günlüğünde kalır.',
    success: 'Belge silindi.',
  },
  preview: {
    error: 'Önizleme yüklenemedi.',
    previousPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
    page: 'Sayfa',
    zoom: 'Yakınlaştır',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    rotateLeft: 'Sola döndür',
    rotateRight: 'Sağa döndür',
    fullscreen: 'Tam ekran',
    textTruncated: 'Metin önizlemesi, izleyicinin yanıt vermesini sağlamak için kısaltıldı.',
    uploadedAt: "{{date}}'de yüklendi",
  },
  errors: {
    list: 'Belgeler yüklenemedi.',
    download: 'İndirme başarısız oldu.',
    entityMissing: 'İlgili ERP varlığı eksik.',
    size: "“{{name}}” boş veya 50 MB'tan büyük.",
    uploadFile: '“{{name}}” yüklenemedi.',
  },
  tabs: {
    partner: 'Belgeler ve sözleşmeler',
    product: 'Dosyalar ve veri sayfaları',
    documentDetails: 'Belge verileri',
    documentAttachments: 'Ekler',
  },
  batch: {
    title: 'Toplu belgeler',
    subtitle: '{{product}} · Toplu {{batch}}',
    back: 'Ürüne geri dön',
    filesTitle: 'Analiz sertifikaları ve laboratuvar raporları',
    loadError: 'Toplu iş yüklenemedi.',
  },
} as const;
